import React from "react";

const Header = () => {
  return (
    <header tabIndex="0">Happy tweets by M</header>
  );
};

export default Header;